export type ToastType = 'success' | 'warning' | 'error' | 'info';

export type ToastAction = {
  label: string;
  onClick: () => void;
};

export type ToastInput = {
  title: string;
  description?: string;
  /** Omit for default duration; `null` keeps the toast until manually dismissed. */
  durationMs?: number | null;
  /** Optional button shown under the description (e.g. copy failed text). */
  action?: ToastAction;
};

export type Toast = ToastInput & {
  id: string;
  type: ToastType;
  /** `null` keeps the toast visible until manually dismissed. */
  durationMs: number | null;
};

export const DEFAULT_TOAST_DURATION_MS = 5000;
export const MAX_VISIBLE_TOASTS = 3;
export const TOAST_EXIT_DURATION_MS = 200;
